import { sendExceptionToSentry, showMessage } from 'h-commons';
import { CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY, DEFAULT_ERROR_MESSAGE } from './constants';

export const handleError = (err) => {
  sendExceptionToSentry(err);
  const errorMessage = err.response?.data?.message;
  showMessage({ message: errorMessage || DEFAULT_ERROR_MESSAGE, type: 'error' });
};

export const commonQueryOptions = {
  retry: 1,
  refetchOnWindowFocus: false,
};

// Utility function to remove duplicates based on a given property
export const removeDuplicate = (property, dataArray, acceptNullValue) => {
  if (Array.isArray(dataArray)) {
    return dataArray.reduce((unique, item) => {
      const value = item[property];
  
      if ((value === null && acceptNullValue) || (value !== null && !unique.some((t) => t[property] === value))) {
        unique.push(item)
      }
  
      return unique;
    }, []);
  }

  return []
};
  
// Callback function to update table dimensions based on container's bounding box
export const updateTableDimensions = (setTableDimensions) => {
  return (elementRef) => {
    if (!elementRef) return;
    const rect = elementRef.getBoundingClientRect();
    if (rect) {
      const { top, width } = rect;
      setTableDimensions((previousDimensions) => {
        const headerOffset = previousDimensions.height + top;
        const availableHeight = window.innerHeight - headerOffset;
        
        // Update state only if there's a change in height or width
        if (previousDimensions.height !== availableHeight || previousDimensions.width !== width) {
          return { height: availableHeight, width };
        }
        return previousDimensions;
      });
    }
  };
};

export const getCustomFieldDataFromState = (state = {}) => {
  return {
    cfHeading: state.cfHeading,
    cfName: state.cfName,
    cfDescription: state.cfDescription,
    cfShowIcon: state.cfShowIcon,
    cfDropdownDefaultValue: state.cfDropdownDefaultValue,
    cfDropdownOptions: state.cfDropdownOptions,
    cfStatus: state.cfStatus,
    cfRequired: state.cfRequired,
    cfAiPromptState: state.cfAiPromptState,
    cfAiPromptText: state.cfAiPromptText,
    cfAiInitialPromptText: state.cfAiInitialPromptText,
    cfAiInitialPromptState: state.cfAiInitialPromptState,
  } 
}

export const getCustomFieldDataFromListQuery = (queryData, cfId) => {
  const customFieldsList = queryData?.data?.data;

  if (!Array.isArray(customFieldsList)) {
    return {};
  }
    const customFields = customFieldsList[0]?.custom_fields
    const currentCustomFieldData = customFields?.filter((field) => field.cf_id === cfId)[0];
    const dropdownDefaultValueId = currentCustomFieldData.dropdown_default_value;
    const dropdownDefaultValue = dropdownDefaultValueId
      ? currentCustomFieldData.dropdown_values.find(value => value.id === dropdownDefaultValueId)?.display_name || null
      : null


    return {
      cfHeading: currentCustomFieldData.display_name,
      cfName: currentCustomFieldData.display_name,
      cfDescription: currentCustomFieldData.description,
      cfShowIcon: currentCustomFieldData.info_icon,
      cfDropdownDefaultValue: dropdownDefaultValue,
      cfDropdownOptions: currentCustomFieldData.dropdown_values,
      cfStatus: currentCustomFieldData.status,
      cfRequired: currentCustomFieldData.mandatory ?? false,
      cfAiPromptState: Boolean(currentCustomFieldData.ai_prompt),
      cfAiPromptText: currentCustomFieldData.ai_prompt ?? "",
      cfAiInitialPromptText: currentCustomFieldData.ai_prompt ?? "",
      cfAiInitialPromptState: Boolean(currentCustomFieldData.ai_prompt),
    }
}

export const setTestConversationLocalStorage = () => {
  return localStorage.setItem(CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY, "true");
}

export const isTestConversationClickedOnce = () => {
  return localStorage.getItem(CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY) === "true";
}

export const clearTestConversationClickedLocalStorage = () => {
  return localStorage.removeItem(CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY);
}